<template>
  <div class="newwarp boxsizing miniwarp">
    <div class="auto">
      <page-title title="访问" icon="fa-compass"></page-title>
    </div>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div class="padding-15">
          <dufault-column height="auto" title="用户访问" tooltip="所选时间内用户访问情况及往期对比" v-loading="loading">
            <div slot="bar">
              <dates-picker v-model="hDate" size="mini" style="margin-right:15px;"></dates-picker>
              <el-radio-group v-model="interval" size="mini">
                <el-radio-button :label="item.value" v-for="(item, index) in options" :key="index">{{item.label}}</el-radio-button>
              </el-radio-group>
            </div>
            <div slot="content">
              <el-row>
                <el-col :span="4">
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      UV
                      <el-tooltip class="item" effect="dark" content="时间段内用户访问人数" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.uv || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      PV
                      <el-tooltip class="item" effect="dark" content="时间段内用户访问次数" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.pv || 0)}}</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="20">
                  <echarts :data="chartData1" title="" height="270" :nohader="true"></echarts>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column title="访问方式 " tooltip="按场景值分布" :nomargin="true" height="auto" v-loading="loading1">
            <div slot="bar">
              <dates-picker v-model="hDate1" size="mini"></dates-picker>
              <!-- <composite-date :tag="tagId" @change="changeTagId"></composite-date> -->
            </div>
            <div slot="content">
              <el-table :data="totalData1">
                <el-table-column label=" " width="20"></el-table-column>
                <!-- <el-table-column prop="id" label="场景值ID" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="getDetail(scope.row)">{{scope.row.id}}</el-button>
                  </template>
                </el-table-column> -->
                <el-table-column prop="name" label="场景值名称">
                  <template slot-scope="scope">
                    <!-- {{scope.row.name}} -->
                    <el-button type="text" size="small" @click="getSenceDetail(scope.row, 'sence')">{{scope.row.name}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="new_user" sortable label="新用户数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.new_user)}}
                  </template>
                </el-table-column>
                <el-table-column prop="user" sortable label="总用户数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.user)}}
                  </template>
                </el-table-column>
                <el-table-column prop="total" sortable label="总次数" width="120px">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.total)}}
                  </template>
                </el-table-column>
              </el-table>
              <div class="pageBox" v-if="tableData1.length > pageSize">
                <el-pagination
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  @current-change="tablePage1"
                  :current-page.sync="page1"
                  :total="tableData1.length"
                  align="right">
                </el-pagination>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column title="访问页面 " tooltip="按 Path 分布" :nomargin="true" height="auto" v-loading="loading2">
            <div slot="bar">
              <dates-picker v-model="hDate2" size="mini"></dates-picker>
              <!-- <composite-date :tag="tagId2" @change="changeTagId2"></composite-date> -->
            </div>
            <div slot="content">
              <el-table :data="totalData2">
                <el-table-column label=" " width="20"></el-table-column>
                <el-table-column prop="name" label="页面路径" width="320px">
                  <template slot-scope="scope">
                    <!-- {{scope.row.name}} -->
                    <el-button type="text" size="small" @click="getRouteDetail(scope.row, 'route')">{{scope.row.name}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="app_onshow_user" sortable label="启动人数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.app_onshow_user)}}
                  </template>
                </el-table-column>
                <el-table-column prop="app_onshow_total" sortable label="启动次数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.app_onshow_total)}}
                  </template>
                </el-table-column>
                <el-table-column prop="page_onshow_user" sortable label="打开人数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.page_onshow_user)}}
                  </template>
                </el-table-column>
                <el-table-column prop="page_onshow_total" sortable label="打开次数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.page_onshow_total)}}
                  </template>
                </el-table-column>
                <el-table-column prop="app_onhide_user" sortable label="关闭人数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.app_onhide_user)}}
                  </template>
                </el-table-column>
                <el-table-column prop="app_onhide_total" sortable label="关闭次数" width="120px">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.app_onhide_total)}}
                  </template>
                </el-table-column>
              </el-table>
              <div class="pageBox" v-if="tableData2.length > pageSize">
                <el-pagination
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  @current-change="tablePage2"
                  :current-page.sync="page2"
                  :total="tableData2.length"
                  align="right">
                </el-pagination>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column title="访问来源 " tooltip="按来源分布" :nomargin="true" height="auto" v-loading="loading3">
            <div slot="bar">
              <dates-picker v-model="hDate3" size="mini"></dates-picker>
              <!-- <composite-date :tag="tagId3" @change="changeTagId3"></composite-date> -->
            </div>
            <div slot="content">
              <el-table :data="totalData3">
                <el-table-column label=" " width="20"></el-table-column>
                <el-table-column prop="name" label="渠道名称" width="320px">
                  <template slot-scope="scope">
                    <!-- {{scope.row.name}} -->
                    <el-button type="text" size="small" @click="getChannleDetail(scope.row, 'channle')">{{scope.row.name}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="new_user" sortable label="新用户数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.new_user)}}
                  </template>
                </el-table-column>
                <el-table-column prop="app_onshow_user" sortable label="打开人数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.app_onshow_user)}}
                  </template>
                </el-table-column>
                <el-table-column prop="app_onshow_total" sortable label="打开次数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.app_onshow_total)}}
                  </template>
                </el-table-column>
              </el-table>
              <div class="pageBox" v-if="tableData3.length > pageSize">
                <el-pagination
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  @current-change="tablePage3"
                  :current-page.sync="page3"
                  :total="tableData3.length"
                  align="right">
                </el-pagination>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column title="自定义事件" :nomargin="true" height="auto" v-loading="loading4">
            <div slot="bar">
              <dates-picker v-model="hDate4" size="mini"></dates-picker>
              <!-- <composite-date :tag="tagId4" @change="changeTagId4"></composite-date> -->
            </div>
            <div slot="content">
              <el-table :data="totalData4">
                <el-table-column label=" " width="20"></el-table-column>
                <el-table-column prop="name" label="事件名称" width="320px">
                  <template slot-scope="scope">
                    <!-- {{scope.row.name}} -->
                    <el-button type="text" size="small" @click="getCustomDetail(scope.row, 'custom')">{{scope.row.name}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="user" sortable label="触发人数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.user)}}
                  </template>
                </el-table-column>
                <el-table-column prop="total" sortable label="触发次数">
                  <template slot-scope="scope">
                    {{util.numberFormat(scope.row.total)}}
                  </template>
                </el-table-column>
              </el-table>
              <div class="pageBox" v-if="tableData4.length > pageSize">
                <el-pagination
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  @current-change="tablePage4"
                  :current-page.sync="page4"
                  :total="tableData4.length"
                  align="right">
                </el-pagination>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <detail-dialog :title="String(row.name)" :status="dialogStatus" :dialogVisible="dialogVisible" :chartData="dialogChart" :tableHead="dialogTableHead" :tableData="dialogTableData" @tableSortChange="tableSortChange" @visibleFn="visibleFn">
      <div slot="bar" style="text-align: right; padding: 15px;">
        <mini-dates-picker v-model="dialogDate" size="mini" style="margin-right:15px;position: relative; top: 1px;"></mini-dates-picker>
        <el-radio-group v-model="dialogInterval" size="mini">
          <el-radio-button :label="item.value" v-for="(item, index) in options" :key="index">{{item.label}}</el-radio-button>
        </el-radio-group>
      </div>
    </detail-dialog>
  </div>
</template>
<script>
import { Data as DataModel } from '@/model'
import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      loading: false,
      hDate: this.util.getDataPickerDefault(),
      interval: 'week',
      options: [
        {
          value: 'day',
          label: '日'
        },
        {
          value: 'week',
          label: '周'
        },
        {
          value: 'month',
          label: '月'
        },
        {
          value: 'quarter',
          label: '季'
        }
      ],
      header: {},
      chartData1: '',
      pageSize: 5,
      hDate1: this.util.getDataPickerDefault(),
      tagId: '7',
      loading1: false,
      tableData1: [],
      totalData1: [],
      page1: 1,
      hDate2: this.util.getDataPickerDefault(),
      tagId2: '7',
      loading2: false,
      tableData2: [],
      totalData2: [],
      page2: 1,
      hDate3: this.util.getDataPickerDefault(),
      tagId3: '7',
      loading3: false,
      tableData3: [],
      totalData3: [],
      page3: 1,
      hDate4: this.util.getDataPickerDefault(),
      tagId4: '7',
      loading4: false,
      tableData4: [],
      totalData4: [],
      page4: 1,
      row: {},
      dialogVisible: false,
      dialogDate: this.util.getDataPickerDefault(),
      dialogInterval: 'week',
      dialogStatus: true,
      dialogChart: {},
      dialogTableData: [],
      dialogTableHead: [],
      dialogType: 'sence'
    }
  },
  watch: {
    'hDate': function (val) {
      this.getPvAndUv()
    },
    'interval': function (val) {
      this.getPvAndUv()
    },
    'hDate1': function (val) {
      this.page1 = 1
      this.getBehaviorScene()
    },
    'hDate2': function (val) {
      this.page2 = 1
      this.getBehaviorRoute()
    },
    'hDate3': function (val) {
      this.page3 = 1
      this.getBehaviorFromchannle()
    },
    'hDate4': function (val) {
      this.page4 = 1
      this.getBehaviorCustom()
    },
    'dialogInterval': function (val) {
      if (this.dialogVisible) {
        switch (this.dialogType) {
          case 'sence':
            this.getSenceDetailFn(this.row)
            break;
          case 'route':
            this.getRouteDetailFn(this.row)
            break;
          case 'channle':
            this.getChannleDetailFn(this.row)
            break;
          case 'custom':
            this.getCustomDetailFn(this.row)
            break;
          default:
            break;
        }
      }
    },
    'dialogDate': function (val, oldval) {
      if (this.dialogVisible) {
        switch (this.dialogType) {
          case 'sence':
            this.getSenceDetailFn(this.row)
            break;
          case 'route':
            this.getRouteDetailFn(this.row)
            break;
          case 'channle':
            this.getChannleDetailFn(this.row)
            break;
          case 'custom':
            this.getCustomDetailFn(this.row)
            break;
          default:
            break;
        }
      }
    }
  },
  methods: {
    tableSortChange (column) {
      var dialogTableData = this.dialogTableData
      this.util.arraySort(dialogTableData, column['prop'], column['order'])
      this.dialogTableData = dialogTableData
    },
    visibleFn (val) {
      this.dialogVisible = val
      this.dialogStatus = true
      this.interval = 'week'
    },
    async getCustomDetailFn (row, sort) {
      this.row = row
      if (!this.dialogVisible && String(this.dialogDate) !== String(this.hDate4)) {
        this.dialogDate = this.hDate4
      }
      this.dialogVisible = true
      this.dialogStatus = !this.dialogStatus
      let res = await DataModel.Miniv2.getBehaviorCustomDetail({
        begin_time: this.dialogDate[0],
        end_time: this.dialogDate[1],
        interval: this.dialogInterval,
        key: row.key
      })
      if (!res['err_code']) {
        let chart = {}
        if (res['data'].length) {
          res['data'].map(item => {
            chart[item.name] = item
          })
        }
        this.dialogChart = DataController.Mini.behaviorOverviewLine4(JSON.parse(JSON.stringify(chart)))
        this.dialogTableData = res['data'] || []
      }
    },
    getCustomDetail (row, type) {
      this.row = row
      this.dialogTableHead = [
        {
          title: '日期',
          tag: 'name',
          sort: true
        },
        {
          title: '人数',
          tag: 'user',
          sort: true,
          thousand: true
        },
        {
          title: '次数',
          tag: 'total',
          sort: true,
          thousand: true
        }
      ]
      this.dialogType = type
      this.dialogVisible = true
      this.dialogDate = Object.assign([], this.hDate4)
    },
    async getChannleDetailFn (row, sort) {
      this.row = row
      if (!this.dialogVisible && String(this.dialogDate) !== String(this.hDate3)) {
        this.dialogDate = this.hDate3
      }
      this.dialogVisible = true
      this.dialogStatus = !this.dialogStatus
      let res = await DataModel.Miniv2.getBehaviorFromchannleDetail({
        begin_time: this.dialogDate[0],
        end_time: this.dialogDate[1],
        interval: this.dialogInterval,
        key: row.key
      })
      if (!res['err_code']) {
        let chart = {}
        if (res['data'].length) {
          res['data'].map(item => {
            chart[item.name] = item
          })
        }
        this.dialogChart = DataController.Mini.behaviorOverviewLine3(JSON.parse(JSON.stringify(chart)))
        this.dialogTableData = res['data'] || []
      }
    },
    getChannleDetail (row, type) {
      this.row = row
      this.dialogTableHead = [
        {
          title: '日期',
          tag: 'name',
          sort: true
        },
        {
          title: '新用户数',
          tag: 'new_user',
          sort: true,
          thousand: true
        },
        {
          title: '打开人数',
          tag: 'app_onshow_user',
          sort: true,
          thousand: true
        },
        {
          title: '打开次数',
          tag: 'app_onshow_total',
          sort: true,
          thousand: true
        }
      ]
      this.dialogType = type
      this.dialogVisible = true
      this.dialogDate = Object.assign([], this.hDate3)
    },
    async getRouteDetailFn (row, sort) {
      this.row = row
      if (!this.dialogVisible && String(this.dialogDate) !== String(this.hDate2)) {
        this.dialogDate = this.hDate2
      }
      this.dialogVisible = true
      this.dialogStatus = !this.dialogStatus
      let res = await DataModel.Miniv2.getBehaviorRouteDetail({
        begin_time: this.dialogDate[0],
        end_time: this.dialogDate[1],
        interval: this.dialogInterval,
        key: row.key
      })
      if (!res['err_code']) {
        let chart = {}
        if (res['data'].length) {
          res['data'].map(item => {
            chart[item.name] = item
          })
        }
        this.dialogChart = DataController.Mini.behaviorOverviewLine2(JSON.parse(JSON.stringify(chart)))
        this.dialogTableData = res['data'] || []
      }
    },
    getRouteDetail (row, type) {
      this.row = row
      this.dialogTableHead = [
        {
          title: '日期',
          tag: 'name',
          sort: true
        },
        {
          title: '启动人数',
          tag: 'app_onshow_user',
          sort: true,
          thousand: true
        },
        {
          title: '启动次数',
          tag: 'app_onshow_total',
          sort: true,
          thousand: true
        },
        {
          title: '打开人数',
          tag: 'page_onshow_user',
          sort: true,
          thousand: true
        },
        {
          title: '打开次数',
          tag: 'page_onshow_total',
          sort: true,
          thousand: true
        },
        {
          title: '关闭人数',
          tag: 'app_onhide_user',
          sort: true,
          thousand: true
        },
        {
          title: '关闭次数',
          tag: 'app_onhide_total',
          sort: true,
          thousand: true
        }
      ]
      this.dialogType = type
      this.dialogVisible = true
      this.dialogDate = Object.assign([], this.hDate2)
    },
    async getSenceDetailFn (row, sort) {
      this.row = row
      if (!this.dialogVisible && String(this.dialogDate) !== String(this.hDate1)) {
        this.dialogDate = this.hDate1
      }
      this.dialogVisible = true
      this.dialogStatus = !this.dialogStatus
      let res = await DataModel.Miniv2.getBehaviorSceneDetail({
        begin_time: this.dialogDate[0],
        end_time: this.dialogDate[1],
        interval: this.dialogInterval,
        key: row.key
      })
      if (!res['err_code']) {
        let chart = {}
        if (res['data'].length) {
          res['data'].map(item => {
            chart[item.name] = item
          })
        }
        this.dialogChart = DataController.Mini.behaviorOverviewLine1(JSON.parse(JSON.stringify(chart)))
        this.dialogTableData = res['data'] || []
      }
    },
    getSenceDetail (row, type) {
      this.row = row
      this.dialogTableHead = [
        {
          title: '日期',
          tag: 'name',
          sort: true
        },
        {
          title: '新用户数',
          tag: 'new_user',
          sort: true,
          thousand: true
        },
        {
          title: '打开人数',
          tag: 'user',
          sort: true,
          thousand: true
        },
        {
          title: '打开次数',
          tag: 'total',
          sort: true,
          thousand: true
        }
      ]
      this.dialogType = type
      this.dialogVisible = true
      this.dialogDate = Object.assign([], this.hDate1)
    },
    async getPvAndUv () {
      this.loading = true
      let res = await DataModel.Miniv2.getPvAndUv({
        begin_time: this.hDate[0],
        end_time: this.hDate[1],
        interval: this.interval
      })
      if (!res['err_code']) {
        this.header = res['data'] || {}
        this.chartData1 = DataController.Mini.behaviorOverviewBarAndLine(this.header['list'] || '')
      }
      this.loading = false
    },
    changeTagId (val) {
      this.hDate1 = val
    },
    sortChange1 (column) {
      var tableData1 = this.tableData1
      this.util.arraySort(tableData1, column['prop'], column['order'])
      this.tablePage1(1)
      this.page1 = 1
      this.tableData1 = tableData1
    },
    tablePage1 (val) {
      this.totalData1 = []
      this.tableData1.filter((item, index) => {
        var max = val * this.pageSize
        var min = (val - 1) * this.pageSize
        if (index >= min && index < max) {
          this.totalData1.push(item)
        }
      })
    },
    async getBehaviorScene () {
      this.loading1 = true
      let res = await DataModel.Miniv2.getBehaviorScene({
        begin_time: this.hDate1[0],
        end_time: this.hDate1[1]
      })
      this.loading1 = false
      if (!res['err_code']) {
        this.tableData1 = JSON.parse(JSON.stringify(res['data']))
        this.tablePage1(1)
      }
    },
    changeTagId2 (val) {
      this.hDate2 = val
    },
    sortChange2 (column) {
      var tableData2 = this.tableData2
      this.util.arraySort(tableData2, column['prop'], column['order'])
      this.tablePage2(1)
      this.page2 = 1
      this.tableData2 = tableData2
    },
    tablePage2 (val) {
      this.totalData2 = []
      this.tableData2.filter((item, index) => {
        var max = val * this.pageSize
        var min = (val - 1) * this.pageSize
        if (index >= min && index < max) {
          this.totalData2.push(item)
        }
      })
    },
    async getBehaviorRoute () {
      this.loading2 = true
      let res = await DataModel.Miniv2.getBehaviorRoute({
        begin_time: this.hDate2[0],
        end_time: this.hDate2[1]
      })
      this.loading2 = false
      if (!res['err_code']) {
        this.tableData2 = JSON.parse(JSON.stringify(res['data']))
        this.tablePage2(1)
      }
    },
    changeTagId3 (val) {
      this.hDate3 = val
    },
    sortChange3 (column) {
      var tableData3 = this.tableData3
      this.util.arraySort(tableData3, column['prop'], column['order'])
      this.tablePage3(1)
      this.page3 = 1
      this.tableData3 = tableData3
    },
    tablePage3 (val) {
      this.totalData3 = []
      this.tableData3.filter((item, index) => {
        var max = val * this.pageSize
        var min = (val - 1) * this.pageSize
        if (index >= min && index < max) {
          this.totalData3.push(item)
        }
      })
    },
    async getBehaviorFromchannle () {
      this.loading3 = true
      let res = await DataModel.Miniv2.getBehaviorFromchannle({
        begin_time: this.hDate3[0],
        end_time: this.hDate3[1]
      })
      this.loading3 = false
      if (!res['err_code']) {
        this.tableData3 = JSON.parse(JSON.stringify(res['data']))
        this.tablePage3(1)
      }
    },
    changeTagId4 (val) {
      this.hDate4 = val
    },
    sortChange4 (column) {
      var tableData4 = this.tableData34
      this.util.arraySort(tableData4, column['prop'], column['order'])
      this.tablePage4(1)
      this.page4 = 1
      this.tableData4 = tableData4
    },
    tablePage4 (val) {
      this.totalData4 = []
      this.tableData4.filter((item, index) => {
        var max = val * this.pageSize
        var min = (val - 1) * this.pageSize
        if (index >= min && index < max) {
          this.totalData4.push(item)
        }
      })
    },
    async getBehaviorCustom () {
      this.loading4 = true
      let res = await DataModel.Miniv2.getBehaviorCustom({
        begin_time: this.hDate4[0],
        end_time: this.hDate4[1]
      })
      this.loading4 = false
      if (!res['err_code']) {
        this.tableData4 = JSON.parse(JSON.stringify(res['data']))
        this.tablePage4(1)
      }
    }
  },
  created () {
    this.getPvAndUv()
    this.getBehaviorScene()
    this.getBehaviorRoute()
    this.getBehaviorFromchannle()
    this.getBehaviorCustom()
  }
}
</script>

<style scoped>
.useraddbox {
  flex: 1;
}
.useraddbox p {
  font-size: 30px;
  font-weight: 300;
  padding: 20px 0 30px;
}
.nopadbotbox .useraddbox p {
  padding-bottom: 0;
}
</style>
